export const product = [
    {
        title:"WE'LL HELP YOU —",
        desc1:"Get-your-business-online",
        desc2:"Market Your Business",
    },{
        title:"PLATFORM FEATURES —",
        desc1:"Audience Management",
        desc2:"Creative Tools",
        desc3:"Insights & Analytics"
    },
    {
        title:"NOT SURE WHERE TO START? —",
        desc1:"Whats's Right For Me",
        desc2:"Marketing Automation"
    }
]